/**
 * 配置数据
 */
export const gConfig = {

  oss_http:'http://aegiswxbj.oss-cn-beijing.aliyuncs.com/',
  oss_http1:"http://cjword.oss-cn-beijing.aliyuncs.com/",
  //本地测试配置
  // url_cms_server : "http://127.0.0.1:8001/",
  // url_shop_server : "http://127.0.0.1:8003/",
  // url_account_server : "http://127.0.0.1:8000/",

  //测试服务器配置
  // url_cms_server : "http://testcmsserver.market.ivr.aegis-vr.com/",
  // url_shop_server : "http://testserver.shop.ivr.aegis-vr.com/",
  // url_account_server : "http://testivr.aegis-vr.com/",



  //正式服务器配置

  url_cms_server : "https://cmsserver.market.ivr.aegis-vr.com/",
  url_shop_server : "https://server.shop.ivr.aegis-vr.com/",
  url_account_server : "https://ivr.aegis-vr.com/",


  //混合配置

  // url_cms_server : "https://cmsserver.market.ivr.aegis-vr.com/",
  // url_shop_server : "http://127.0.0.1:8003/",
  // url_account_server : "https://ivr.aegis-vr.com/",


}



// WEBPACK FOOTER //
// ./src/assets/js/data/Config.js